import { Card, Col, Progress, Row, Tag, Tooltip, Typography } from 'antd';
import TopMerchantsTable from './TopMerchantsTable';
import React from 'react';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/es/typography/Paragraph';
import CardHoldersChart from './charts/card-holders-chart';
import NationalTransactionsChart from './charts/national-transactions-chart';
import InternationalTransactionsChart from './charts/international-transactions-chart';
import DailyTotalTransactions from './charts/daily-total-transactions';
import ApprovedTransactionsType from './charts/approved-transactions-types-chart';
import RejectedTransactionsType from './charts/rejected-transactions-types-chart';
import { CreditCardOutlined, CloudOutlined } from '@ant-design/icons';

const MainStatistics = ({
  loading,
  topMerchantsData,
  loadingTopMerchants,
  transactionsData,
  loadingTransactionsData,
  platformData,
  loadingPlatformData
}) => {

  return (
    <Row gutter={24}>
      <Col span={10}>
        <div
          style={{
            top: 0,
            left: 0,
            width: '100%',
            height: '250px',
            backgroundColor: '#6950E8',
            borderRadius: '16px 16px 0 0',
          }}
        >
          <CardHoldersChart currentQuarter={platformData?.cardholders?.total} />
        </div>
        <Card
          loading={loading}
          style={{
            minHeight: '420px',
            height: '400px',
            borderRadius: '0px 0px 16px 16px',
          }}
          bodyStyle={{ padding: 0 }}
          bordered={false}
        >
          <Row gutter={24} style={{ margin: '1rem' }}>
            <Col span={12}>
              <Card
                style={{
                  backgroundColor: 'rgb(246, 247, 248)',
                  borderRadius: '16px',
                  top: '-70px',
                  height: '200px',
                  paddingLeft: '24px 0px 24px 0px'
                }}
              >
                <Title
                  level={3}
                  style={{ marginBottom: '0px' }}
                >
                  {
                    new Intl.NumberFormat('es-AR', {
                      style: 'currency',
                      currency: 'ARS',
                    }).format(transactionsData?.detail?.national?.amount || 0)
                  }
                </Title>
                <Paragraph type="secondary">Nacionales</Paragraph>
                <NationalTransactionsChart lastWeek={transactionsData?.detail?.international?.last_week} />
              </Card>
            </Col>
            <Col span={12}>
              <Card
                style={{
                  backgroundColor: 'rgb(246, 247, 248)',
                  borderRadius: '16px',
                  top: '-70px',
                  height: '200px',
                }}
              >
                <Title
                  level={4}
                  style={{ marginBottom: '0px' }}
                >{
                  new Intl.NumberFormat('es-AR', {
                    style: 'currency',
                    currency: 'ARS',
                  }).format(transactionsData?.detail?.international?.amount || 0)
                }</Title>
                <Paragraph type="secondary">Internacionales</Paragraph>
                <InternationalTransactionsChart lastWeek={transactionsData?.detail?.international?.last_week} />
              </Card>
            </Col>
            <Col span={12}>
              <Card
                style={{
                  backgroundColor: 'rgb(246, 247, 248)',
                  borderRadius: '16px',
                  top: '-50px',
                  height: '200px',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                  <Title style={{ marginBottom: '0px' }}>{platformData?.cardholders?.created}</Title>
                </div>
                <Paragraph type="secondary">Cardholders nuevos</Paragraph>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                  <Title style={{ marginBottom: '0px' }}>{platformData?.cardholders?.total}</Title>
                </div>
                <Paragraph type="secondary">Cardholders totales</Paragraph>
              </Card>
            </Col>
            <Col span={12}>
              <Card
                style={{
                  backgroundColor: 'rgb(246, 247, 248)',
                  borderRadius: '16px',
                  top: '-50px',
                  height: '200px',
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                  <Title level={2} style={{ marginBottom: '0px' }}>{platformData?.cards?.total}</Title>
                  {
                    platformData?.cards?.created > 0 ?
                      (
                        <div style={{ display: 'flex', gap: '5px', left: '15px', top: '0px' }}>
                          <Tag color="green">
                            <Typography.Text style={{ color: 'rgb(17, 184, 134)' }}>
                              +{platformData?.cards?.created}
                            </Typography.Text>
                          </Tag>
                        </div>
                      )
                    : ""
                  }
                </div>
                <Paragraph type="secondary">Cards</Paragraph>
                <Tooltip
                  title={`Virtuales ${platformData?.cards?.total > 0 ? Math.round((platformData?.cards?.types_detail[0]?.total / platformData?.cards?.total) * 100) : 0}%`}
                  placement="topLeft">
                <div style={{ display: 'flex', gap: '5px' }}>
                    <CloudOutlined style={{ color: '#F4A261', fontSize: '22px', marginLeft: '-2px' }} />
                    <Progress
                      strokeColor={ '#F4A261' }
                      percent={platformData?.cards?.total > 0 ? Math.round((platformData?.cards?.types_detail[0]?.total / platformData?.cards?.total) * 100) : 0}
                      showInfo={false}
                    />
                    <span>{platformData?.cards?.types_detail[0]?.total}</span>
                  </div>
                </Tooltip>
                <Tooltip title={`Fisicas ${ platformData?.cards?.total > 0 ? Math.round((platformData?.cards?.types_detail[1]?.total / platformData?.cards?.total) * 100) : 0 }%`} placement="topLeft">
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <CreditCardOutlined style={{ color: '#6950E8', fontSize: '20px' }} />
                    <Progress
                      strokeColor={'#6950E8'}
                      percent={platformData?.cards?.total > 0 ? Math.round((platformData?.cards?.types_detail[1]?.total / platformData?.cards?.total) * 100) : 0}
                      showInfo={false}
                    />
                    <span>{platformData?.cards?.types_detail[1]?.total}</span>
                  </div>
                </Tooltip>
              </Card>
            </Col>
          </Row>
        </Card>
      </Col>

      <Col span={14}>
        <Card
          loading={loading}
          bordered={false}
          style={{
            height: '340px',
            minHeight: '340px',
            borderRadius: '16px',
            padding: '0px',
          }}
        >
          <Row gutter={24}>
            <Col span={12}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'start', width: '100%' }}>
                <Title style={{ marginBottom: '0px' }}>200.000</Title>
                <div style={{ display: 'flex', gap: '5px', left: '5px' }}>
                  <Tag color="green">
                    <Typography.Text style={{ color: 'rgb(17, 184, 134)' }}>
                      +$5.000.000
                    </Typography.Text>
                  </Tag>
                </div>
              </div>
              <Paragraph type="secondary">Transacciones totales diarias</Paragraph>
              <Row style={{ display: 'flex', alignItems: 'center' }}>
                <Col span={12} style={{ display: 'flex', justifyContent: 'center' }}>
                  <DailyTotalTransactions transactionsData={transactionsData} />
                </Col>
                <Col
                  span={12}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                  }}
                >
                  <div style={{ textAlign: 'center' }}>
                    <Typography.Text style={{ fontSize: '18px', fontWeight: 'bold' }}>{transactionsData?.approved?.total}</Typography.Text>
                    <Paragraph type="secondary">Aprobadas</Paragraph>
                  </div>
                  <div style={{ textAlign: 'center' }}>
                    <Typography.Text style={{ fontSize: '18px', fontWeight: 'bold' }}>{transactionsData?.rejected?.total}</Typography.Text>
                    <Paragraph type="secondary">Rechazadas</Paragraph>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col span={12}>
              <div style={{ display: 'flex', justifyContent: 'start', width: '100%' }}>
                <Title style={{ marginBottom: '0px' }}>Origen</Title>
              </div>
              <Paragraph type="secondary">Nacionales e Internacionales</Paragraph>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Col span={12}>
                  <ApprovedTransactionsType transactionsData={transactionsData} />
                  <Paragraph type="secondary" style={{ textAlign: 'center'}}>Aprobadas</Paragraph>
                </Col>
                <Col span={12}>
                  <RejectedTransactionsType transactionsData={transactionsData} />
                  <Paragraph type="secondary" style={{ textAlign: 'center'}}>Rechazadas</Paragraph>
                </Col>
              </div>
            </Col>
          </Row>
        </Card>

        <Card
          loading={loading}
          bordered={false}
          style={{
            minHeight: '319px',
            maxHeight: '319px',
            overflow: 'scroll',
            borderRadius: '16px',
            padding: '0px',
            top: '10px'
          }}
        >
          <TopMerchantsTable
            topMerchantsData = { topMerchantsData }
            loadingTopMerchants = { loadingTopMerchants }
          />
        </Card>
      </Col>
    </Row>
  )
}

export default MainStatistics;